if (!customElements.get('movitamins-products')) {
  customElements.define(
    'movitamins-products',
    class MovitaminsProducts extends HTMLElement {
      connectedCallback() {
        // Add to cart and the delivery promise also serve the collection grid, which has no carousel.
        this.live = this.querySelector('[data-products-live]');
        if (!this.onAddClickBound) {
          this.onAddClickBound = this.onAddClick.bind(this);
          this.addEventListener('click', this.onAddClickBound);
        }
        window.MovitaminsDelivery?.register?.(this);

        this.viewport = this.querySelector('[data-products-viewport]');
        this.list = this.querySelector('[data-products-list]');
        this.previous = this.querySelector('[data-products-previous]');
        this.next = this.querySelector('[data-products-next]');
        this.thumb = this.querySelector('[data-products-thumb]');
        this.carousel = this.querySelector('[data-products-carousel]');
        if (!this.viewport || !this.list) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.animating = false;
        this.onScroll = this.update.bind(this);
        this.onResize = this.update.bind(this);

        this.previous?.addEventListener('click', () => this.move(-1));
        this.next?.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.update();
      }

      disconnectedCallback() {
        this.viewport?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }

      cardStep() {
        const card = this.list.querySelector('.mvp__item');
        if (!card) return this.viewport.clientWidth;
        const styles = getComputedStyle(this.list);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      maxScroll() {
        return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      }

      update() {
        const max = this.maxScroll();
        const left = this.viewport.scrollLeft;
        // Marks a carousel where every card already fits, so a section can hide its controls.
        this.classList.toggle('is-static', max <= 2);
        if (this.previous) this.previous.disabled = left <= 2;
        if (this.next) this.next.disabled = left >= max - 2;
        if (this.thumb) {
          const visible = this.viewport.scrollWidth ? this.viewport.clientWidth / this.viewport.scrollWidth : 1;
          const travel = max ? left / max : 0;
          this.thumb.style.width = `${Math.max(visible * 100, 10)}%`;
          this.thumb.style.transform = `translateX(${travel * (100 / Math.max(visible, 0.1) - 100)}%)`;
        }
        const image = this.list.querySelector('.mvp__image');
        if (image && this.carousel) {
          this.carousel.style.setProperty('--image-mid', `${image.offsetTop + image.offsetHeight / 2}px`);
        }
      }

      move(direction) {
        const step = this.cardStep();
        const max = this.maxScroll();
        const current = this.viewport.scrollLeft;
        const index = Math.round(current / step);
        const target = Math.min(max, Math.max(0, (index + direction) * step));
        this.scrollToPosition(target);
      }

      scrollToPosition(target) {
        const from = this.viewport.scrollLeft;
        const distance = target - from;
        if (Math.abs(distance) < 1) return;
        if (this.reducedMotion.matches) {
          this.viewport.scrollLeft = target;
          this.update();
          return;
        }
        if (this.animating) cancelAnimationFrame(this.frame);
        this.animating = true;
        const duration = 520;
        const start = performance.now();
        const snap = this.viewport.style.scrollSnapType;
        this.viewport.style.scrollSnapType = 'none';
        const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2);
        const frame = (now) => {
          const t = Math.min(1, (now - start) / duration);
          this.viewport.scrollLeft = from + distance * ease(t);
          if (t < 1) {
            this.frame = requestAnimationFrame(frame);
            return;
          }
          this.viewport.style.scrollSnapType = snap;
          this.animating = false;
          this.update();
        };
        this.frame = requestAnimationFrame(frame);
      }

      onAddClick(event) {
        const button = event.target.closest('[data-add-to-cart]');
        if (!button || button.disabled) return;
        event.preventDefault();
        this.addToCart(button);
      }

      addToCart(button) {
        const id = button.getAttribute('data-variant-id');
        const title = button.getAttribute('data-product-title') || '';
        if (!id) return;
        button.disabled = true;
        button.classList.add('is-added');
        const cart = document.querySelector('cart-drawer');
        const formData = new FormData();
        formData.append('id', id);
        formData.append('quantity', '1');
        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(button);
        }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData,
        })
          .then((response) => response.json())
          .then((state) => {
            if (state.status) {
              button.disabled = false;
              button.classList.remove('is-added');
              if (this.live) this.live.textContent = state.description || state.message || '';
              return;
            }
            if (cart) cart.renderContents(state);
            if (this.live) this.live.textContent = `${title} toegevoegd aan de winkelwagen`;
            setTimeout(() => button.classList.remove('is-added'), 900);
          })
          .catch(() => {
            button.classList.remove('is-added');
          })
          .finally(() => {
            button.disabled = false;
          });
      }
    }
  );
}
